export default __webpack_public_path__ + "static/media/account_circle_blue.506fff58.svg";